import React from 'react'
//import {Link} from 'react-router-dom';
//import card2 from '../img/Airtime.svg'


function Faqcard(props) {

  return (
    <div className='Aboutcard' onClick={props.toggleall}>



    <div className='about-container bg'>
        <div className='about-text'>
            <h2>Frequently Asked Questions</h2>
            {/* <div className='card-img'>
            <img src={card2} alt="Airtime and Data Topup" />
            </div> */}

            <span>We are updating our FAQ. </span>
            <span>Please check back later. </span>
            
        </div>
        
    </div>


    </div>
  )
}

export default Faqcard